import React from "react";

export const Contact = () => {
  return (
    <>
      <section className="hero is-fullheight mb-5">
        <div className="hero">
          <h1>About & Contact</h1>
        </div>
        <div className="columns">
          <div className="column fadeLeftMini">
            <h2>
              MMCC® - Early-Stage Investment Opportunity
            </h2>
            <p>
              Mobile Mint Car Care launched mid-2023 as a zero-carbon waterless 
              automotive care service. With 18 months of operational experience, 
              established major retail partnership (under NDA), and active fuel 
              retailer negotiations, we seek £75,000-£125,000 investment to scale 
              operations across Surrey & Greater London.
            </p>
          </div>
          <div className="column">
            <h2>
              Investment Inquiry Contact
            </h2>
            <p>
              For investment opportunities and partnership discussions, please 
              contact our business development team. We provide comprehensive 
              investment documentation including partnership contracts (redacted), 
              operational data, and detailed growth projections. All inquiries 
              are handled confidentially with appropriate NDA protections.
            </p>
          </div>
          <div className="column fadeRightMini">
            <h2>
              Business Development & Partnership Services
            </h2>
            <p>
              Our established service portfolio includes waterless car wash 
              (£25-£90), ceramic coating (£150-£330), PureShield protection, 
              mobile ozone odour removal (£50+), and fleet cleaning. Over 1034 
              cars serviced and growing. Current partnerships demonstrate proven 
              B2B capability with potential for significant scaling through 
              investment funding and operational expansion.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
